import type { InternalAxiosRequestConfig } from 'axios'
import { TENANT_COOKIE } from '@/utils/constants'

export async function getTenantInterceptorRequest(
  config: InternalAxiosRequestConfig,
) {
  // Verifica se a URL contém /session ou /tennants
  const shouldAddTenant =
    config.url?.includes('/session') ||
    config.url?.includes('/tennants') ||
    config.url?.includes('/public')

  if (config.url?.includes('/tennants/get-all-tennants')) {
    return config
  }

  if (!shouldAddTenant) {
    return config
  }

  if (typeof window === 'undefined') {
    const { cookies } = await import('next/headers')
    let tenant = null
    try {
      tenant = JSON.parse(cookies().get(TENANT_COOKIE)?.value || 'null')
    } catch (error) {
      console.error('Error parsing tenant cookie (server):', error)
      tenant = null
    }

    if (tenant?.id) {
      Object.assign(config.headers || {}, {
        tennant: tenant.id,
      })
    }

    return config
  }

  const Cookies = (await import('js-cookie')).default
  let tenant = null
  try {
    tenant = JSON.parse(Cookies.get(TENANT_COOKIE) || 'null')
  } catch (error) {
    console.error('Error parsing tenant cookie (client):', error)
    tenant = null
  }

  if (tenant?.id) {
    Object.assign(config.headers || {}, {
      tennant: tenant.id,
    })
  }

  return config
}
